/** DevExtreme DataGrid: kayıt adedine göre yükseklik (max üstüne çıkmaz). */
export function gridHeightByRowCount(count, maxHeight, {
  rowH = 34,
  headerH = 56,
  pad = 10,
} = {}) {
  const n = Math.max(0, Number(count) || 0);
  const maxH = Number(maxHeight);
  const h = Math.round((n * rowH) + headerH + pad);
  const minH = headerH + pad;
  const cappedMax = Number.isFinite(maxH) && maxH > 0 ? maxH : h;
  return Math.min(cappedMax, Math.max(minH, h));
}

/** N satırlık sabit max yükseklik (mevcut panel limitleri için). */
export function gridMaxHeightForRows(maxRows, opts) {
  const n = Math.max(0, Number(maxRows) || 0);
  return gridHeightByRowCount(n, Number.POSITIVE_INFINITY, opts);
}

/** Satış satırları: CAS_REF azalan (yeni üstte). */
export function sortSatisRowsByRefDesc(rows) {
  const list = Array.isArray(rows) ? [...rows] : [];
  const ref = (r) => Number(r?.CAS_REF ?? r?.cas_ref ?? 0) || 0;
  return list.sort((a, b) => ref(b) - ref(a));
}
